import { kinks } from '3rd-party-wrappers/turf';

const _isVertexInPolygon = (vertexToFind, polygon) =>
  polygon.coordinates.some(ring =>
    ring.some(vertex => vertex[0] === vertexToFind[0] && vertex[1] === vertexToFind[1])
  );

/** @param polygon A valid (except for maybe kinks) Polygon.
    @returns true if any kinks were found, false if not. */
export const isPolygonKinked = (polygon) => {
  const fc = kinks(polygon);
  if (fc === undefined) { throw new Error('kinks() failed'); }

  /* If self-intersections were returned (features.length > 0) check for "good" vs "bad" kind.
    "bad" = twists in the shape (line intersecting another line causing unintended and hard to interpret shapes).
    "good" = point intersections that were part of the original polygon. */
  return fc.features.some(feature => {
    const type = feature.geometry.type;
    if (type !== 'Point') { return true; }
    return (!_isVertexInPolygon(feature.geometry.coordinates, polygon));
  });
};
